<template>
  <el-dialog
    v-dialogDrag
    width="560px"
    class="mini-dialog"
    :title="uploadZipProps.title"
    :visible.sync="uploadZipProps.visible"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-upload
      ref="upload"
      action="https://xx.yy.zz"
      class="!w-full !block"
      :multiple="false"
      :auto-upload="false"
      :on-change="onChange"
      :before-upload="beforeUpload"
      :http-request="importListFile"
      :show-file-list="false"
      :on-exceed="handleExceed"
    >
      <template>
        <div class="flex justify-between items-center">
          <el-input placeholder="文件名" readonly v-model="fileObj.fileName"></el-input>
          <el-button type="primary" size="small">点击上传</el-button>
        </div>

        <div class="el-upload__tip" slot="tip" v-if="!fileObj || !fileObj.id">
          只能上传压缩包，限制{{ this.maxSize }}M
        </div>
        <div class="el-upload__tip" slot="tip" v-else>
          <span
            class="pl-10px cursor-pointer text-red-500"
            v-if="errFileId"
            @click="downLoadFile(errFileId)"
            >查看导入结果</span
          >
        </div>
      </template>
    </el-upload>
    <div slot="footer">
      <el-button type="primary" @click="closeDialog()" size="small">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'
import { ContractorPersonnelApi } from '@wiz-api/contractor-management'

const fileApi = new FileApi()
const contractorPersonnelApi = new ContractorPersonnelApi()
export default {
  name: 'batch-upload-zip',
  props: {
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @param {excel类型} excelType
     * @return {*}
     */
    uploadZipProps: {
      type: Object,
      default: () => {
        return {
          visible: false,
          title: '人员批量导入',
          excelType: '',
        }
      },
    },
    // 文件大小不超过，单位m，默认100，
    maxSize: {
      type: Number,
      default: 50,
    },
    // 可上传文件类型
    accept: {
      type: Array,
      default: () => {
        return ['zip']
      },
    },
  },
  data() {
    return {
      // 上传文件对象
      fileObj: {},
      // 错误说明详情文件id
      errFileId: '',
      // code标识 0 失败 1 成功
      code: null,
    }
  },
  methods: {
    // 文件导入自定义方法
    async importListFile(params) {
      // 上传附件
      const [err, res] = await fileApi.upload({
        files: [params.file],
      })
      if (!err) {
        this.fileObj = res[0]
        // 上传成功后
        const [errFile, resFile] = await contractorPersonnelApi.importContractorPersonnels({
          id: this.fileObj.id,
        })
        if (!errFile) {
          this.code = resFile.code
          // 上传成功
          if (resFile.code === 1) {
            this.$message({
              showClose: true,
              message: '导入成功',
              type: 'success',
            })
          } else {
            this.errFileId = resFile.data
            this.$message({
              showClose: true,
              message: resFile.msg,
              type: 'error',
            })
          }
        }
      }
    },
    // 文件超出限制钩子
    handleExceed() {
      this.$message({
        showClose: true,
        message: '文件个数超出限制',
        type: 'warning',
      })
    },
    beforeUpload(file) {
      const maxSize = file.maxSize / 1024 / 1024
      const name = file.name
      if (maxSize > this.maxSize) {
        this.$message({
          showClose: true,
          message: `上传文件大小不能超过${this.maxSize}M`,
          type: 'warning',
        })
        return false
      }
      const fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (
        !this.accept
          .map((i) => {
            return i.toLowerCase()
          })
          .includes(fileSuffix)
      ) {
        this.$message({
          showClose: true,
          message: `上传文件只能是${this.accept.join('/')}`,
          type: 'warning',
        })
        return false
      }
      return true
    },
    onChange(file, fileList) {
      this.$refs.upload.submit()
      this.$refs.upload.clearFiles()
    },
    // 附件，下载
    async downLoadFile(file) {
      const [err, res] = await fileApi.download(file, { returnType: 'Blob' })
      if (!err) {
        this.exportFile(res)
      }
    },
    // 下载文件
    exportFile(data) {
      const blob = new Blob([data], {
        type: 'application/octet-stream',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', '错误说明详情.xlsx')
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        showClose: true,
        message: '下载成功!',
        type: 'success',
      })
    },
    // 关闭弹窗
    async closeDialog() {
      this.$emit('refreshList')
      this.uploadZipProps.visible = false
      this.fileObj = {}
      // 删除错误文件说明文档
      if (this.errFileId) {
        const [err, res] = await fileApi.deleteVersion(this.errFileId)
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-upload {
  width: 100%;
}
</style>
